import { render, staticRenderFns } from "./KnowledgeContentMoveView.vue?vue&type=template&id=19db9f96&"
import script from "./KnowledgeContentMoveView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentMoveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports